export default "__VITE_ASSET__CLz15kJo__"